var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShieldDollarOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.74014 10.6079C6.96855 11.0428 7.42463 11.3395 7.94999 11.3395H9.51072C10.3188 11.3395 10.9739 10.6844 10.9739 9.87627C10.9739 9.06818 10.3188 8.41309 9.51072 8.41309H8.04753C7.23944 8.41309 6.58434 7.758 6.58434 6.9499C6.58434 6.1418 7.23944 5.48671 8.04753 5.48671H9.60827C10.1336 5.48671 10.5897 5.78337 10.8181 6.21831M8.77913 4.38932V5.48671M8.77913 11.3395V12.4369M14.6319 8.77888C14.6319 12.3699 10.715 14.9816 9.28977 15.8131C9.1278 15.9076 9.04682 15.9548 8.93253 15.9793C8.84383 15.9983 8.71442 15.9983 8.62573 15.9793C8.51143 15.9548 8.43045 15.9076 8.26848 15.8131C6.8433 14.9816 2.92638 12.3699 2.92638 8.77888V5.28011C2.92638 4.69519 2.92638 4.40273 3.02204 4.15134C3.10655 3.92925 3.24388 3.73109 3.42215 3.57398C3.62395 3.39614 3.89779 3.29345 4.44546 3.08807L8.36812 1.61707C8.52021 1.56004 8.59626 1.53152 8.6745 1.52022C8.74389 1.51019 8.81436 1.51019 8.88376 1.52022C8.96199 1.53152 9.03804 1.56004 9.19013 1.61707L13.1128 3.08807C13.6605 3.29345 13.9343 3.39614 14.1361 3.57398C14.3144 3.73109 14.4517 3.92925 14.5362 4.15134C14.6319 4.40273 14.6319 4.69519 14.6319 5.28011V8.77888Z",
    stroke: "#F37721",
    strokeWidth: 1.72281,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldDollarOrange);
export default __webpack_public_path__ + "static/media/shield-dollar-orange.92576a3e133efd367433f998840ed28e.svg";
export { ForwardRef as ReactComponent };